import React from 'react';
import './App.css';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import Services from './components/Services/Services';
import LocationHours from './components/LocationHours/LocationHours';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';
import Analytics from './components/Analytics';

function App() {
  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <About />
        <Services />
        <LocationHours />
        <Contact />
      </main>
      <Footer />
      <Analytics 
        site="elitecleanersva.com" 
        apiKey="elitecleaners-7f8a9b2c3d4e" 
      />
    </div>
  );
}

export default App;
